import { captureException } from 'works/legacy/lib/sentry';

import { ERROR_TYPES } from './error-handler-constants';

type NotifiableError = string | Error;

function areAllErrorsWithSameCode(
  errorsCode: (string | undefined)[],
  firstErrorCode: string | undefined
) {
  return errorsCode.every((errorCode) => errorCode === firstErrorCode);
}

function getErrorsCodeList(graphQLErrors: { extensions?: { code: string } }[]) {
  return graphQLErrors.map((error) => error?.extensions?.code);
}

export function getCodeFromErrors(graphQLErrors: unknown) {
  if (!Array.isArray(graphQLErrors)) {
    return ERROR_TYPES.UNEXPECTED;
  }

  const errorsCode = getErrorsCodeList(graphQLErrors);
  const [firstErrorCode] = errorsCode;

  if (areAllErrorsWithSameCode(errorsCode, firstErrorCode)) {
    return firstErrorCode;
  }

  return ERROR_TYPES.UNEXPECTED;
}

export function notifyUnhandledError(error: NotifiableError, log?: string) {
  console.error(`'ErrorHandler: ${log || ''}`, error);
  captureException(error);
}
